import { useEffect, useState } from 'react';
import { DrawApi } from '@apply/api';
import { ConfirmModal } from '../../../../../../../ui/src';
import dayjs from 'dayjs';

interface IApprovedCheckboxProps {
    drawBudget?: DrawApi.IDrawBudget;
    isAdmin: boolean;
    onApprovalAdd: () => void;
    isReadOnly?: boolean;
}

export const ApprovedCheckbox = ({
    drawBudget,
    isAdmin,
    onApprovalAdd,
    isReadOnly = false,
}: IApprovedCheckboxProps): JSX.Element => {
    const [approved, set_approved] = useState<boolean>(false);
    const [isConfirmModalOpen, set_isConfirmModalOpen] = useState<boolean>(false);

    useEffect(() => {
        if (!drawBudget?.currentApproval) set_approved(false);
    }, [drawBudget?.currentApproval]);

    const onConfirmApproval = () => {
        set_approved(true);
        set_isConfirmModalOpen(false);
        onApprovalAdd();
    };

    const onCancelApproval = () => {
        set_approved(false);
        set_isConfirmModalOpen(false);
    };

    const onApprovalCheckboxClick = () => {
        set_isConfirmModalOpen(true);
    };

    const approvalText = isAdmin
        ? `Approved by ${drawBudget?.currentApproval?.approvedBy} on ${dayjs(drawBudget?.currentApproval?.approvedOn).format('M/D/YY')}`
        : `Approved on ${dayjs(drawBudget?.currentApproval?.approvedOn).format('M/D/YY')}`;

    if (drawBudget?.currentApproval) {
        return (
            <p
                style={{
                    textAlign: 'left',
                    marginTop: 13,
                    fontWeight: 400,
                    minWidth: 200,
                }}
            >
                {approvalText}
            </p>
        );
    }

    if (isAdmin) {
        return (
            <div
                className='draw-head-center-checkbox-div'
                title={isReadOnly ? 'This Budget is read only.' : ''}
            >
                <input
                    type='checkbox'
                    checked={approved}
                    className='draw-head-center-checkbox-input'
                    onChange={onApprovalCheckboxClick}
                    disabled={isReadOnly}
                />
                <label
                    htmlFor='equityRequirement'
                    className='draw-head-center-checkbox-label'
                    onClick={onApprovalCheckboxClick}
                >
                    Approved
                </label>
                <ConfirmModal
                    confirmButtonText={'Approved'}
                    isOpen={isConfirmModalOpen}
                    confirmCallback={onConfirmApproval}
                    cancelCallback={onCancelApproval}
                >
                    {drawBudget?.approvals?.length > 0 && (
                        <>
                            <div
                                style={{
                                    width: 300,
                                    border: '1px solid #344077',
                                    padding: 20,
                                    margin: 'auto',
                                }}
                            >
                                <h2 className='decorated'>Approval History</h2>
                                <ul style={{ listStyleType: '' }}>
                                    {drawBudget.approvals.map((approval, index) => {
                                        return (
                                            <li key={index}>
                                                {approval.approvedBy} on {dayjs(approval.approvedOn).format('M/D/YY')}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                            <br />
                            <br />
                        </>
                    )}
                    <p
                        style={{
                            fontSize: 16,
                            color: '#344077',
                            fontWeight: 600,
                            textAlign: 'center',
                        }}
                    >
                        I have confirmed that the Credit Committee
                        <br />
                        has approved this budget.
                    </p>
                </ConfirmModal>
            </div>
        );
    }

    return (
        <p
            style={{
                textAlign: 'left',
                marginTop: 13,
                fontWeight: 400,
                minWidth: 200,
                color: '#ab1715',
            }}
        >
            Waiting for approval
        </p>
    );
};
